export const projectsData = [
  {
    id: 1,
    title: 'Holifi',
    description:
      'A web app for generating holiday-themed parodies for your favorite song lyrics.',
    image: '/static/images/holifi.png',
    tech: ['React', 'MaterialUI', 'Firebase', 'Flask'],
    github: 'http://github.com/JKornberg/Holifi',
    demo: 'http://youtu.be/etscCIaG4Pg',
  },
  {
    id: 2,
    title: 'Game Sort',
    description: 'A web app for finding your next favorite game to play.',
    image: '/static/images/game-sort.png',
    tech: ['React', 'Python'],
    github: 'https://github.com/Brian-Magnuson/GameSort',
    demo: 'http://youtu.be/OHTmz7PoKVk',
  },
  {
    id: 3,
    title: 'Student Budget Tracker',
    description: 'A web app for tracking your budget and managing finances.',
    image: '/static/images/budget-tracker.png',
    tech: ['Angular', 'Golang', 'MySQL', 'AWS'],
    github: 'https://github.com/spwalgren/Student-Budget-Tracker',
    demo: 'http://youtu.be/uOvboRxIuWU',
  },
  {
    id: 4,
    title: 'Spreaddit',
    description:
      'A mobile app that allows users to efficiently upload the same post to multiple communities on reddit.',
    image: '/static/images/spreaddit.png',
    tech: ['React Native', 'SQLite'],
    github: 'https://github.com/GraysonKornberg/Spreaddit',
    demo: 'https://youtu.be/hQNB6TxKva4',
  },
  {
    id: 5,
    title: 'Playlist Proximity',
    description: `An exploratory data analysis project on Spotify's Million Playlist Dataset. User's can pick an artist of their choice and examine statistics about them and their related artists.`,
    image: '/static/images/playlist-proximity.png',
    tech: ['Python', 'Pandas', 'Matplotlib', 'NumPy'],
    github: 'https://github.com/GraysonKornberg/Playlist-Proximity',
    demo: 'http://youtu.be/WlLPbBWoIv8',
  },
]
